import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import NaturesCountReportPage from "../components/NaturesCountReportPage";

const NaturesCountReport = () => (
  <MasterLayout>
    <NaturesCountReportPage />
  </MasterLayout>
);

export default NaturesCountReport;
